import React, { Fragment } from 'react';

import Image from './image/Image';
import GenericHeader from './pageHeader/GenericHeader';
import { configs } from '@constants/configs/configs';

function errorIllustrationUrl(stateCode) {
    const slug = String(stateCode || 'gi').toLowerCase();

    return configs.ENV.DEVELOPMENT
        ? `../../../assets/images/${slug}-error-illustration.png`
        : configs.endpoints.IMAGES.processReplacements({
            relativePath: '/resources/img',
            fileName: `${slug}-error-illustration.png`,
        });
}


/**
 * Shared layout + illustration for fatal client error pages. Used by `SsapSummaryFallback` and
 * `ApplicationErrorFallback`; callers supply the primary action (e.g. refresh vs reload) as `children`.
 */
const ClientErrorFallbackLayout = ({ mainId, headerId, stateCode, children }) => {
    const errorImage = errorIllustrationUrl(stateCode);

    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section" id={mainId}>
                <div className="grid-container gi-grid-container">
                    <div className="grid-row grid-gap gi-wrapper gi-fallback">
                        <div className="desktop:grid-col-4 tablet:grid-col-4 mobile:grid-col-12 gi-fallback__item gi-fallback__content">
                            <GenericHeader
                                tag="h2"
                                id={headerId}
                                text="session.error.header"
                                headerClassName={[
                                    'mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__header',
                                ]}
                            />
                            {children}
                        </div>
                        <div className="desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__item gi-fallback__img">
                            <Image
                                {...{
                                    source: errorImage,
                                    desc: 'session.error.content.img.desc',
                                    name: 'system__error_img',
                                    classes: [],
                                }}
                            />
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

export default ClientErrorFallbackLayout;
